import { useEffect } from "react";
import { Navigate, useParams } from "react-router-dom";
import { translate } from "../../utils/i18n";
import {
  VALID_LANG_CODES,
  VALID_ROUTE_CATEGORIES,
  languageCodeToId,
  gameHomePath,
} from "../../utils/routes";
export function LangRouteSync() {
  const { lang } = useParams();

  useEffect(() => {
    if (!lang || !VALID_LANG_CODES.includes(lang)) return;
    const langId = languageCodeToId(lang);
    try {
      window.localStorage.setItem("language", langId);
    } catch (e) {
      // ignore
    }
    if (typeof translate.changeLanguage === "function") {
      const current =
        typeof translate.currentLanguage === "function"
          ? translate.currentLanguage()
          : null;
      if (current !== langId) {
        translate.changeLanguage(langId);
      }
    }
  }, [lang]);

  return null;
}

/** 校验 /:lang/:category 列表页路由参数 */
export function LangCategoryLayout({ children }) {
  const { lang, category } = useParams();

  if (!VALID_LANG_CODES.includes(lang)) {
    return <Navigate to={gameHomePath()} replace />;
  }
  if (!VALID_ROUTE_CATEGORIES.includes(category)) {
    return <Navigate to={gameHomePath({ lang })} replace />;
  }

  return (
    <>
      <LangRouteSync />
      {children}
    </>
  );
}

/** 校验 /:lang/... 详情页路由中的 lang 参数 */
export function LangDetailLayout({ children }) {
  const { lang } = useParams();

  if (!VALID_LANG_CODES.includes(lang)) {
    return <Navigate to={gameHomePath()} replace />;
  }

  return (
    <>
      <LangRouteSync />
      {children}
    </>
  );
}

/** /:lang 单独访问时重定向到 /:lang/game */
export function LangOnlyRedirect() {
  const { lang } = useParams();

  if (!VALID_LANG_CODES.includes(lang)) {
    return <Navigate to={gameHomePath()} replace />;
  }

  return (
    <>
      <LangRouteSync />
      <Navigate to={gameHomePath({ lang })} replace />
    </>
  );
}
